import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormPanel, FormSelect, FormTextField } from '@eas/common-web';
import { useIpEntryModes } from './ip-entry-api';

export function Fields() {
  const modes = useIpEntryModes();

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="TAPIS__IP_ENTRY__DETAIL__PANEL__BASIC_INFO"
          defaultMessage="Základní informace"
        />
      }
    >
      <FormTextField
        name="ip"
        label={
          <FormattedMessage
            id="TAPIS__IP_ENTRY__DETAIL__FIELD_LABEL__IP"
            defaultMessage="IP Adresa"
          />
        }
        required
      />
      <FormSelect
        name="mode"
        label={
          <FormattedMessage
            id="TAPIS__IP_ENTRY__DETAIL__FIELD_LABEL__MODE"
            defaultMessage="Mód"
          />
        }
        source={modes}
        valueIsId
        required
      />
    </FormPanel>
  );
}
